<div *ngIf="!(alertService.authorizationError | async) && alertService.errors.length" class="errors">
	<ng-container *ngFor="let error of alertService.errors; index as i">
		<div class="error" [class.fade-out]="closingIndexes.includes(i)">
			<div class="header">An error has occurred</div>
			<div class="body">
				<div class="message">{{ error }}</div>
				<button mat-button (click)="close(i)">Close</button>
			</div>
		</div>
	</ng-container>
</div>
